import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/Title.svg'


const _withScopeId = n => (_pushScopeId("data-v-7eb69e80"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { "aria-label": "Close" }, "×", -1))
const _hoisted_3 = { class: "content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  height: "111",
  width: "320",
  alt: "q4 Logo"
}, null, -1))
const _hoisted_5 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, {
    name: "modal",
    onAfterEnter: _ctx.afterFadeIn,
    onBeforeLeave: _ctx.beforeFadeOut
  }, {
    default: _withCtx(() => [
      (_ctx.showModal)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "container",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickBackground && _ctx.clickBackground(...args)))
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("h2", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showModal = false))
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.title), 1),
                _hoisted_2
              ]),
              _createElementVNode("div", _hoisted_3, [
                _renderSlot(_ctx.$slots, "default", {}, () => [
                  _hoisted_4
                ], true),
                (_ctx.message)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.message), 1))
                  : _createCommentVNode("", true),
                _renderSlot(_ctx.$slots, "buttons", {}, undefined, true)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["onAfterEnter", "onBeforeLeave"]))
}